import {useToast} from '@chakra-ui/react';
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {pinsPanoIdSearchRequest} from '../../../../reducers/pinsReducer';
import MinimapPanoMarker from '../MinimapPanoMarker';
import PanoToastContent from './PanoToastContent';

const MinimapPanoToast = ({}) => {
  const dispatch = useDispatch();

  // const isEditingPin = pathname.endsWith('pins/edit');
  // const isList = pathname.endsWith('pins/pins');


  const panoId = useSelector(s => s.inApp.panoId);
  const panoLocation = useSelector(s => s.inApp.panoLocation);
  const isPanoLoaded = panoId && panoLocation;

  const [reopenToast, setReopenToast] = useState(0);

  const toast = useToast();
  const toastIdRef = useRef();

  useEffect(() => {
    const closeCurrentToast = () => toast.close(toastIdRef.current);

    if (panoId) {
      toast.closeAll();
      toastIdRef.current = toast({
        render: () => <PanoToastContent />,
        duration: null,
        icon: <></>,
        isClosable: false,
        position: 'bottom',
      });
    } else {
      closeCurrentToast();
    }

    return closeCurrentToast;
  }, [panoId, reopenToast]);

  useEffect(() => {
    if (panoId) {
      dispatch(pinsPanoIdSearchRequest({
        isNew: true,
        panoId,
      }));
    }
  }, [panoId]);

  return isPanoLoaded && <MinimapPanoMarker isCurrentPano onClick={() => setReopenToast(reopenToast + 1)}/>;
};

export default MinimapPanoToast;
